<script>
import HomeHero from "@/components/home/hero/HomeHero";
import ContentSplit from "@/components/content/split/ContentSplit";
import ContentDiptych from "@/components/content/diptych/ContentDiptych";
import ContentSlider from "@/components/content/slider/ContentSlider";
import ContentFooter from "@/components/content/footer/ContentFooter";

export default {
  name: "BodyHome",
  components: {
    HomeHero,
    ContentSplit,
    ContentDiptych,
    ContentSlider,
    ContentFooter
  }
};
</script>
<style lang="stylus" scoped>
@import "BodyHome"
@import "BodyHomeFarming"
@import "BodyHomeWildlife"
</style>
